import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_V1_URL } from '../../../core/config/api.config';
import { LoginResponse } from '../../login/models/login-response.model';

export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
}

@Injectable({
    providedIn: 'root',
})
export class ChangePasswordService {
    private readonly http = inject(HttpClient);
    private readonly apiBaseUrl = API_V1_URL;
    changePassword(request: ChangePasswordRequest): Observable<LoginResponse> {
        return this.http.put<LoginResponse>(
            `${this.apiBaseUrl}/profile/password`,
            request
        );
    }
}